import { SvgIconProps } from "../types";

export const SvgIcon = ({ src, alt, width, height }: SvgIconProps) => (
  <img src={`/img/svg/${src}`} alt={alt} width={width} height={height}/>
);
